import React from 'react';

export type ProgressSegment = {
  label: string;
  value: number;
  className: string;
};

/** A horizontal bar split into segments, each as wide as its share of the total. */
export function ProgressBar({ segments, label }: { segments: ProgressSegment[]; label: string }) {
  const total = segments.reduce((sum, s) => sum + s.value, 0);
  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={total}
      aria-valuenow={segments[0]?.value ?? 0}
      className="flex h-3 w-full overflow-hidden rounded bg-dl-track"
    >
      {total > 0 &&
        segments
          .filter(s => s.value > 0)
          .map(s => (
            <div
              key={s.label}
              title={`${s.label}: ${s.value}`}
              className={s.className}
              style={{ width: `${(100 * s.value) / total}%` }}
            />
          ))}
    </div>
  );
}
